import { hasAdminAuthorizationHeader, refreshAdminAccessToken, resolveAdminAccessToken } from './adminAccessToken';

const readBrowserCookie = (): string => (typeof document === 'undefined' ? '' : document.cookie);

/** 관리자 API 요청 헤더: 저장된 관리자 토큰(Bearer)과 XSRF 쿠키. */
export const buildAdminRequestHeaders = (
  accessToken: string | null | undefined,
  cookie: string = readBrowserCookie(),
): Record<string, string> => {
  const resolvedAccessToken = resolveAdminAccessToken(accessToken);
  const headers: Record<string, string> = resolvedAccessToken ? { Authorization: `Bearer ${resolvedAccessToken}` } : {};
  const xsrfCookie = cookie.split('; ').find((row) => row.startsWith('XSRF-TOKEN='));
  if (xsrfCookie) {
    headers['X-XSRF-TOKEN'] = xsrfCookie.split('=')[1];
  }
  return headers;
};

/** 토큰이 없으면 refresh token 으로 한 번 갱신해 붙인다. 갱신도 실패하면 Authorization 없이 돌려준다. */
export const ensureAdminRequestHeaders = async (
  accessToken: string | null | undefined,
  refresh: () => Promise<string | null> = refreshAdminAccessToken,
  cookie: string = readBrowserCookie(),
): Promise<Record<string, string>> => {
  const headers = buildAdminRequestHeaders(accessToken, cookie);
  if (hasAdminAuthorizationHeader(headers)) {
    return headers;
  }
  const refreshedToken = await refresh();
  return refreshedToken ? { ...headers, Authorization: `Bearer ${refreshedToken}` } : headers;
};
